export default {"src":"/_next/static/media/phone-hand-100.1f54ccb6.svg","height":2541,"width":1975,"blurWidth":0,"blurHeight":0};